import { Box, Button, Href, Text } from '@factorialco/deprecated-design-system'
import { useToggle } from 'usehooks-ts'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { DeleteAttachedFileModal } from './DeleteAttachedFileModal'

interface Props {
  filename: string
  url: string
  fileId: number
}

export const AttachedAtsFile = ({ filename, url, fileId }: Props) => {
  const [deleteModalOpen, toggleDeleteModalOpen] = useToggle(false)

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      gap="s16"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      paddingX="s24"
      paddingY="s16"
      background="grey000White"
      maxWidth="full"
    >
      <Text.Normal size="300" weight="medium" color="grey1000" ellipsis>
        {filename}
      </Text.Normal>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end" width="sidebarLogoSize">
          <Href href={url} target="_blank" download={filename}>
            <PopoverMenu.TouchableOption title={i18n.t('common.download')} />
          </Href>
          <PopoverMenu.TouchableOption
            title={i18n.t('common.destroy')}
            danger
            onClick={() => toggleDeleteModalOpen()}
          />
        </PopoverMenu.Content>
      </PopoverMenu>
      {deleteModalOpen && (
        <DeleteAttachedFileModal fileId={fileId} onClose={() => toggleDeleteModalOpen()} />
      )}
    </Box>
  )
}
